/**
 * True when the last name differs only by letter casing (same characters).
 * Used to skip name-change document requirements for capitalization fixes.
 *
 * Uses `toLowerCase()` (not locale-aware lowercasing) so the check stays aligned
 * with backend `casecmp?` / ASCII-style case folding.
 */
export const isLastNameCasingOnlyChange = (currentLastName: string = "", updatedLastName: string = ""): boolean => {
  if (currentLastName === updatedLastName) return false;
  return currentLastName.toLowerCase() === updatedLastName.toLowerCase();
};
